import { render } from "./PriceWorkspace.vue?vue&type=template&id=177b9f1a&scoped=true"
import script from "./PriceWorkspace.vue?vue&type=script&lang=js"
export * from "./PriceWorkspace.vue?vue&type=script&lang=js"

import "./PriceWorkspace.vue?vue&type=style&index=0&id=177b9f1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-177b9f1a"]])

export default __exports__